<template>
  <AccordionRoot
    type="single"
    :collapsible="true"
    @update:modelValue="updateModelValue"
  >
    <slot :activeId="activeId" />
  </AccordionRoot>
</template>

<script setup>
const props = defineProps({
  defaultActiveId: {
    type: Number,
    default: 0,
  },
})

const activeId = ref(props?.defaultActiveId)

const updateModelValue = (value) => {
  activeId.value = value
}
</script>
